import React from 'react';
import { Dropdown, Menu, Spin, Popconfirm, Tooltip } from 'antd';
// Global Styles
import Button from '../../../../shared/globalStyling/Button';
import { ButtonText } from '../../../../shared/globalStyling/styledText';
import { DownloadOutlined, LoadingOutlined } from '@ant-design/icons';

const DynamicDropdownCSVButton = ({ menuItems, disabled = false, loading = false }) => {
  const menu = (
    <Menu>
      {menuItems &&
        menuItems.map((menu) => {
          if (menu.hasConfirm) {
            return (
              <Menu.Item key={menu.key}>
                <Popconfirm title={menu.confirmDescription} onConfirm={menu.onClick}>
                  <Tooltip title={menu.tooltip ? menu.tooltip : null} placement="leftTop">
                    <div>{menu.text ? menu.text : ''}</div>
                  </Tooltip>
                </Popconfirm>
              </Menu.Item>
            );
          } else {
            return (
              <Menu.Item key={menu.key}>
                <Tooltip title={menu.tooltip ? menu.tooltip : null} placement="leftTop">
                  <div onClick={menu.onClick}>{menu.text ? menu.text : ''}</div>
                </Tooltip>
              </Menu.Item>
            );
          }
        })}
    </Menu>
  );

  return (
    <Dropdown overlay={menu} disabled={disabled} trigger={['click']} placement="bottomCenter">
      <Button
        icon={loading ? <Spin indicator={<LoadingOutlined spin />} /> : <DownloadOutlined />}
        type="primary"
        disabled={disabled}
        loading={loading}
      >
        <ButtonText text={'Export CSV'} />
      </Button>
    </Dropdown>
  );
};

export default DynamicDropdownCSVButton;
